import React = require('react');

import { getSessionManagementServiceInstance } from '~src/sessionManagement/SessionManagementService';
import { SiteRolesHelper } from '~src/siteManagement/helpers/SiteRolesHelper';

import { Messages } from '../../../../codegen/Localize';
import { SiteRoles } from '../../../users/serverApi/types/ISiteRole';
import { IGetGroupDetailInfoResult } from '../../models/IGroupInfo';
import { GrantLicenseModes } from '../../serverApi/requests/SyncActiveDirectoryGroupRequest';

export interface GroupDetailsSubspaceProps {
  readonly group: IGetGroupDetailInfoResult;
}

interface GroupDetailsSubspaceState {
  isSavingMinimumSiteRole: boolean;
  isChangingMinimumSiteRoleDetails: boolean;
  groupDetailsModel: IGroupDetailsModel;
  licenseUponLoginCheckboxDisabled: boolean;
  externalUserEnabled?: boolean;
}

export interface IGroupDetailsModel {
  domainName: string;
  createdAt: string;
  updatedAt: string;
  isAllUsersGroup: boolean;
  minimumSiteRole?: string;
  grantLicenseMode?: GrantLicenseModes;
  externalUserEnabled?: boolean;
}

export class GroupDetailsSubspaceComponent extends React.Component<GroupDetailsSubspaceProps, GroupDetailsSubspaceState> {

  private isLocalGroup: boolean = !(this.props.group.domainName && this.props.group.domainName !== 'local');
  private originalGroupDetails: IGetGroupDetailInfoResult = this.props.group;

  public constructor(props: GroupDetailsSubspaceProps) {
    super(props);
    this.state = {
      isSavingMinimumSiteRole: false,
      isChangingMinimumSiteRoleDetails: false,
      groupDetailsModel: {
        domainName: this.props.group.domainName,
        createdAt: this.props.group.createdAt,
        updatedAt: this.props.group.updatedAt,
        isAllUsersGroup: this.props.group.isAllUsersGroup,
        minimumSiteRole: (!this.props.group.minimumSiteRole) ?
          SiteRoles.Unlicensed : this.props.group.minimumSiteRole,
        grantLicenseMode: this.props.group.grantLicenseMode,
        externalUserEnabled: this.props.group.externalUserEnabled
      },
      licenseUponLoginCheckboxDisabled: (!this.isLocalGroup && this.props.group.minimumSiteRole === SiteRoles.Unlicensed)
    };
  }

  public render() {
    const isExternalUserEnabledForSite = getSessionManagementServiceInstance().isExternalUserEnabledForSite();
    return (
      <div className="tb-details">
        <table>
          <tbody>
            {this.isLocalGroup && this.renderRow(Messages.column_domainName(), this.originalGroupDetails.domainName, 'domain')}
            {isExternalUserEnabledForSite && this.getExternalUserEnabled()}
            {this.getSiteRole()}
          </tbody>
        </table>
      </div>
    );
  }

  private getExternalUserEnabled = (): JSX.Element => {
    let externalUserStr = this.state.groupDetailsModel.externalUserEnabled ? Messages.groupEphemeralUsersAllowed(): Messages.groupExternalUserNotAllowed();
    return this.renderRow(Messages.groupEphemeralUsers(), externalUserStr, 'externalUser');
  };

  private getSiteRole = (): JSX.Element => {
    let isEnabled = this.state.groupDetailsModel.grantLicenseMode;
    let minimumSiteRole = this.isLocalGroup && this.state.groupDetailsModel.minimumSiteRole === SiteRoles.Unlicensed ?
    SiteRoles.ExplorerCanPublish : this.state.groupDetailsModel.minimumSiteRole;
    let grantRoleStr = isEnabled ? minimumSiteRole: Messages.groupGrantRoleNotSet();
    return this.renderRow(Messages.groupsMinimumSiteRole(), SiteRolesHelper.siteRoleToName(grantRoleStr), 'grantRole');
  };

  private renderRow = (label: string, value: string, testIdValue: string): JSX.Element => {
    let testStr = 'tb-' + testIdValue + '-value-id';
    return(
      <tr>
      <td className="tb-label">{label}</td>
      <td className="tb-details-value" tb-test-id={testStr} style={this.detailsStyle}>{value}</td>
      </tr>
    );
  };

  private detailsStyle: React.CSSProperties = {
    minWidth: '500px',
  };
}

export const GroupDetailsSubspace: React.ComponentType<GroupDetailsSubspaceProps> = GroupDetailsSubspaceComponent;
